import userAccount from './userAccount';

export default {
    ...userAccount,
};
